// components/HRLoginPage.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from "../components/Navbar";
import loginImage from "../assets/login-page.jpeg";
import api from '../utils/api';
import { handleTenantRedirect } from '../utils/tenantUtils';
import { trackEvent, setUserProperties } from '../utils/analytics';


const HRLoginPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    otp: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const validateRequestOtpLogin = () => {
    let errs = {};
    if (!formData.email.trim()) errs.email = 'Email is required';
    return errs;
  };

  const validateVerifyOtp = () => {
    let errs = {};
    if (!formData.otp.trim()) errs.otp = 'OTP is required';
    if (!formData.email.trim()) errs.email = 'Email is required';
    return errs;
  };

  const requestOtp = async () => {
    const errs = validateRequestOtpLogin();
    if (Object.keys(errs).length) {
      setErrors(errs);
      return false;
    }

    setLoading(true);
    try {
      const body = { email: formData.email };
      const response = await api.post('/api/auth/login-request-otp', body);
      setOtpSent(true);
      setErrors({});
    } catch (e) {
      const errorMsg = e.response?.data?.error || e.message || 'Error requesting OTP';
      setErrors({ submit: errorMsg });
    } finally {
      setLoading(false);
    }
    return true;
  };

  const verifyOtp = async () => {
    const errs = validateVerifyOtp();
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setLoading(true);
    try {
      const body = {
        email: formData.email,
        otp: formData.otp,
      };
      const response = await api.post('/api/auth/login-verify-otp', body);
      const data = response.data;
      
      if (data.user) {
        trackEvent('login', {
          method: 'email_otp',
          role: data.user.role || data.user.user_type || 'HR',
        });
        setUserProperties({
          user_type: data.user.role || data.user.user_type || 'HR',
          org: data.user.org_name || '',
        });
        const redirected = handleTenantRedirect(data.user);
        if (!redirected) {
          localStorage.setItem('user', JSON.stringify(data.user));
          const role = data.user.user_type || data.user.role;
          if (role === 'CANDIDATE') {
            navigate('/candidate-dashboard');
          } else if (role === 'BU_HEAD') {
            navigate('/bu-dashboard');
          } else if (role === 'MANAGER') {
            navigate('/manager-dashboard');
          } else if (role === 'INTERVIEWER') {
            navigate('/interviewer-dashboard');
          } else if (role === 'HR') {
            navigate('/hr-dashboard');
          } else {
            navigate('/interview');
          }
        }
      } else {
        navigate('/interview'); // Fallback
      }
    } catch (e) {
      const errorMsg = e.response?.data?.error || e.message || 'Error verifying OTP';
      setErrors({ submit: errorMsg });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors({});
    if (!otpSent) {
      requestOtp();
    } else {
      verifyOtp();
    }
  };
return (
  <>
    <Navbar />

    <div style={styles.page}>
      <div style={styles.container}>

        {/* LEFT - FORM */}
        <div style={styles.left}>
          <div style={styles.formBox}>
            <h2 style={styles.title}>Welcome Back</h2>
            <p style={styles.subtitle}>
              {!otpSent
                ? 'Login to your account'
                : 'Enter OTP sent to your email'}
            </p>

            <form onSubmit={handleSubmit}>

              {!otpSent && (
                <>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    style={styles.input}
                  />
                  {errors.email && <p style={styles.fieldError}>{errors.email}</p>}
                </>
              )}

              {otpSent && (
                <>
                  <input
                    type="text"
                    name="otp"
                    placeholder="Enter OTP"
                    value={formData.otp}
                    onChange={handleChange}
                    style={styles.input}
                  />
                  {errors.otp && <p style={styles.fieldError}>{errors.otp}</p>}
                </>
              )}

              {errors.submit && (
                <p style={styles.error}>{errors.submit}</p>
              )}

              <button type="submit" style={styles.button}>
                {loading
                  ? 'Please wait...'
                  : otpSent
                  ? 'Verify OTP'
                  : 'Send OTP'}
              </button>

              <p style={styles.switchText}>
                New here?{' '}
                <span
                  onClick={() => navigate('/signup')}
                  style={styles.link}
                >
                  Create account
                </span>
              </p>

            </form>
          </div>
        </div>

        {/* RIGHT - IMAGE */}
        <div style={styles.right}>
          <img
            src={loginImage}
            alt="AI"
            style={styles.image}
          />
         
        </div>

      </div>
    </div>
  </>
);
};

const styles = {
  page: {
    minHeight: 'calc(100vh - 72px)',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'auto',
    background: 'var(--bg-page)',
    padding: '16px 14px',
  },

  container: {
    width: 'min(980px, 100%)',
    minHeight: '480px',
    maxHeight: 'min(580px, 92vh)',
    boxSizing: 'border-box',
    margin: '0 auto',
    display: 'flex',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: 'var(--shadow-lg)',
    border: '1px solid var(--border-light)',
    background: 'var(--bg-card)',
  },

 left: {
  flex: '0 0 43%',
  padding: '24px 20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'var(--bg-card)',
  overflowY: 'auto',
},


//right image 
right: {
  flex: '1',
  position: 'relative',
},

formBox: {
  width: '100%',
  maxWidth: '320px',
},
  title: {
    fontSize: '24px',
    fontWeight: '800',
    marginBottom: '6px',
    color: 'var(--text-primary)',
  },

  subtitle: {
    color: 'var(--text-tertiary)',
    marginBottom: '14px',
    fontSize: '12px',
  },

  input: {
    width: '100%',
    padding: '10px 11px',
    marginBottom: '5px',
    borderRadius: '9px',
    border: '1px solid var(--border-input)',
    fontSize: '12px',
    background: 'var(--bg-input)',
    color: 'var(--text-primary)',
    boxSizing: 'border-box',
  },

  fieldError: {
    color: '#dc2626',
    fontSize: '12px',
    marginBottom: '10px',
    marginTop: '0',
  },

  button: {
    width: '100%',
    padding: '10px',
    background: 'linear-gradient(135deg, #1d4ed8 0%, #3b82f6 100%)',
    color: '#fff',
    border: 'none',
    borderRadius: '9px',
    cursor: 'pointer',
    fontWeight: '700',
    marginTop: '5px',
    boxShadow: '0 10px 20px rgba(29,78,216,0.25)',
  },

  switchText: {
    marginTop: '10px',
    fontSize: '12px',
    textAlign: 'center',
    color: 'var(--text-secondary)',
  },

  link: {
    color: '#818cf8',
    cursor: 'pointer',
    fontWeight: '600',
  },

  error: {
    color: '#dc2626',
    fontSize: '13px',
    marginBottom: '10px',
  },

  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover', 
  },

  overlay: {
    position: 'absolute',
    bottom: '30px',
    left: '30px',
    color: '#fff',
    background: 'rgba(0,0,0,0.5)',
    padding: '20px',
    borderRadius: '10px',
    maxWidth: '300px',
  },
};

export default HRLoginPage;